import { useEffect } from "react";
import { useSelector } from "react-redux";
import { UserSession } from "src/store";
import { Profile } from "../svg";
import LazyLoad from "vanilla-lazyload";
import phUser from "src/assets/static/img/main/icons/ph_user.png";

export const Avatar = () => {

    //#region properties

    const user: UserSession = useSelector((state: any) => state.UserState);

    //#endregion

    //#region  effects

    useEffect(() => {
        const lazyload = new LazyLoad({
            elements_selector: ".profile-img.lazy",
            callback_error: (element: HTMLElement) => {
                const placeholder = element.getAttribute("data-placeholder");
                if (placeholder) element.setAttribute("src", placeholder);
            }
        });

        lazyload.update();

    }, [user.user]);

    //#endregion

    if (user.loggedIn && user.user?.imagePath) {
        return (
            <div style={{ width: "100%", height: "100%", position: "relative" }}>
                <img
                    key={user.user.imagePath || "no-image"}
                    className="profile-img contain lazy"
                    alt=""
                    data-src={user.user.imagePath}
                    data-placeholder={phUser}
                    src={phUser}
                />
            </div>
        );
    }

    return (
        <Profile />
    );

};